module.exports = __webpack_public_path__ + "static/media/search_new.5a49a233.svg";